export default "__VITE_ASSET__f0191a73__"